import type { CSSProperties } from "react";
import {
  ChevronRight,
  Info,
  ArrowLeft,
  ArrowRight,
  RefreshCw,
  LogOut,
  X,
  Menu,
  Image,
  ArrowLeftRight,
  Heart,
  Bookmark,
  Circle,
  CreditCard,
  Banknote,
  ShieldCheck,
  Minus,
  Plus,
  Trash2,
  User,
  ShoppingBag,
  HelpCircle,
} from "lucide-react";

const MAP: Record<string, React.ComponentType<any>> = {
  chevron_right: ChevronRight,
  info: Info,
  west: ArrowLeft,
  east: ArrowRight,
  refresh: RefreshCw,
  logout: LogOut,
  close: X,
  menu: Menu,
  image: Image,
  swap_horiz: ArrowLeftRight,
  favorite: Heart,
  arrow_forward: ArrowRight,
  bookmark: Bookmark,
  radio_button_unchecked: Circle,
  credit_card: CreditCard,
  payments: Banknote,
  banknote: Banknote,
  verified_user: ShieldCheck,
  remove: Minus,
  add: Plus,
  delete: Trash2,
  person: User,
  shopping_bag: ShoppingBag,
};

export function Icon({
  name,
  className = "",
  filled = false,
  size = 22,
  style,
}: {
  name: string;
  className?: string;
  filled?: boolean;
  size?: number;
  style?: CSSProperties;
}) {
  const Comp = MAP[name] || HelpCircle;

  return (
    <Comp
      className={className}
      size={size}
      style={style}
      {...(filled && Comp === Heart ? { fill: "currentColor" } : null)}
    />
  );
}
